import React, { useState, useEffect } from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Button, Divider } from 'antd';
import RichTextEditor from "../RichTextEditor/RichTextEditor";
import useTranslation from '../../hooks/useTranslation';

// Кнопка раскрытия: выглядит подсказкой под разделителем, а для клавиатуры и читалки —
// настоящая кнопка. Мышью ответ открывает клик в любое место карточки, но контейнер
// с tabIndex и без роли обещал бы читалке то, чем не является, а роль кнопки ему нельзя:
// внутри уже есть кнопки оценки.
const revealButtonStyle = {
    display: 'block',
    width: '100%',
    background: 'none',
    border: 'none',
    padding: '8px 0',
    color: '#8e949a',
    cursor: 'pointer',
    font: 'inherit',
    fontSize: '0.9em',
};

function CardCard({
                      card,
                      handleCorrectClick,
                      handleIncorrectClick,
                  }) {
    const isMobile = useIsMobile();
    const { t } = useTranslation();
    const textFontSize = isMobile ? 15 : 20;
    const [showAnswer, setShowAnswer] = useState(false);

    // Функция для отображения ответа при клике
    const handleShowAnswer = () => {
        setShowAnswer(true);
    };

    // Reset showAnswer when a new card is received
    useEffect(() => {
        setShowAnswer(false);
    }, [card]);

    return (
        <div
            style={{
                padding: isMobile ? '0' : '0px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                minHeight: 'calc(100vh - 80px)', // Устанавливаем минимальную высоту
                overflow: 'hidden', // Отключаем скроллинг
            }}
        >
            <Card
                onClick={handleShowAnswer} // ответ открывает клик в любое место карточки
                style={{
                    flex: '1 1 auto',
                    display: 'flex',
                    flexDirection: 'column',
                    padding: '0px'
                }}
            >
                <CardContent style={{ flexGrow: 1, padding: isMobile ? '0px' : '20px' }}>
                    {/* RichTextEditor для отображения вопроса */}
                    <RichTextEditor
                        readOnly={true}
                        initialContent={card.question}
                        fontSize={textFontSize}
                    />

                    {/* Разделитель */}
                    <Divider style={{ margin: isMobile ? '0px 0' : '10px 0'  }} />

                    {!showAnswer && (
                        <button type="button" style={revealButtonStyle} aria-expanded={false} onClick={handleShowAnswer}>
                            {t('practice.run.showAnswer')}
                        </button>
                    )}

                    {/* RichTextEditor для отображения ответа, который скрыт до нажатия */}
                    {showAnswer && (
                        <div>
                            <RichTextEditor
                                readOnly={true}
                                textColor="#6E6E6E"
                                initialContent={card.answer}
                                fontSize={textFontSize}
                            />
                        </div>
                    )}
                </CardContent>

                {/* Кнопки внизу по центру */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        paddingTop: '6px',
                        paddingLeft: '20px',
                        paddingBottom: '20px',
                        paddingRight: '20px',

                    }}
                >
                    <Button
                        onClick={handleCorrectClick}
                        style={{ width: isMobile ? '100%' : '150px', marginRight: '10px' }}
                        disabled={false} // Optionally disable during loading
                    >
                        Correct
                    </Button>
                    <Button
                        onClick={handleIncorrectClick}
                        style={{ width: isMobile ? '100%' : '150px' }}
                        disabled={false} // Optionally disable during loading
                    >
                        Incorrect
                    </Button>
                </div>
            </Card>
        </div>
    );
}

export default CardCard;
